import * as React from "react";
import {BrowserRouter, useLocation, useSearchParams} from "react-router-dom";
import "./assets/styles/main.scss";
import BottomNavigation from "./components/BottomNavigation";
import Support from "./components/support";
import {RouterComponent} from "./routes/Router";
import {SnackbarProvider} from "notistack";
import {store} from "./redux/store";
import {Provider, useSelector} from "react-redux";
import {useTranslation} from "react-i18next";
import $ from 'jquery';
// require('dotenv').config()
// تبدیل یک متغیر لوکال به یک متغیر گلوبال از طریق createContext
export const ThemeContext = React.createContext(null);


export function ScrollToTop() {
  const {pathname} = useLocation();
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

export function Paramss() {
  const [searchParams] = useSearchParams();

  React.useEffect(() => {
    if (!searchParams.get('state')) {
      localStorage.removeItem('token-id')
    }else {
      localStorage.setItem("token-id", searchParams.get('state'))
    }
  }, [searchParams])
}

function App() {

  const {i18n} = useTranslation()
  // const selector = useSelector((st) => st)

  const [darkMode, setDarkMode] = React.useState(false);
  React.useEffect(() => {
    if (!localStorage.getItem('token')) {
      localStorage.removeItem("info-user")
      localStorage.removeItem("token-id")
    }

    const getStorage = async () => {
      let getTheme = await localStorage.getItem('dark_mode')
      await toggleTheme(JSON.parse(getTheme))
    }

    getStorage()

    $(':input').focus(function () {
      var center = $(window).height() / 2;
      var top = $(this).offset().top;
      if (top > center) {
        $(window).scrollTop(top - center);
      }
    });

    document.title = process.env.REACT_APP_SITE === 'amnito' ? 'amnito | امنیتو' : 'Postex | پستِکس';

  }, [])

  // console.log('proccess', process.env.AMNITO)
  // اضافه کردن Attribute به dom پروژه
  document.documentElement.setAttribute('lang', i18n.language);
  document.documentElement.setAttribute('dir', i18n.dir(i18n.language));

  const toggleTheme = async (e) => {
    await localStorage.setItem('dark_mode', e)
    setDarkMode(e)
    if (e) {
      if(process.env.REACT_APP_SITE === 'amnito'){
        document.body.classList.remove('light_theme_amnito')
        document.body.classList.add('dark_theme_amnito')
      }else{
        document.body.classList.remove('light_theme_postex')
        document.body.classList.add('dark_theme_postex')
      }
    } else {
      if(process.env.REACT_APP_SITE === 'amnito'){
        document.body.classList.remove('dark_theme_amnito')
        document.body.classList.add('light_theme_amnito')
      }else{
        document.body.classList.remove('dark_theme_postex')
        document.body.classList.add('light_theme_postex')
      }
    }
  };

  return (
     <Provider store={store}>
       <React.StrictMode>
         <ThemeContext.Provider value={{darkMode, toggleTheme}}>
           <SnackbarProvider maxSnack={1}>

             <BrowserRouter>
               <ScrollToTop/>
               <Paramss/>
               <RouterComponent/>
               {/*<div className="d-none d-lg-block">*/}
               {/*  <Support/>*/}
               {/*</div>*/}
               {/*<div className="d-block d-lg-none">*/}
               {/*  {*/}
               {/*     store?.getState().public.showButtonNavigation && <BottomNavigation/>*/}
               {/*  }*/}
               {/*</div>*/}
             </BrowserRouter>

           </SnackbarProvider>
         </ThemeContext.Provider>
       </React.StrictMode>
     </Provider>
  );
}

export default App;
